// Rent amount min/max in cents
export const MIN_RENT_AMOUNT = 100 * 100;
export const MAX_RENT_AMOUNT = 10000 * 100;

// One time payment max length
export const ONE_TIME_PAYMENT_NOTE_MAX_LENGTH = 45;

// One time payment min amount
export const ONE_TIME_PAYMENT_MIN_AMOUNT = 10 * 100;

// Move-in costs payment min amount
export const MOVE_IN_COSTS_PAYMENT_MIN_AMOUNT = 10 * 100;

// Move-in costs payment max length
export const MOVE_IN_COSTS_NOTE_MAX_LENGTH = 45;

// Term Length End Date allowed options in month for onboarding and setup new term flow
export const TERM_LENGTH_END_DATE_OPTIONS_COUNT = 24;

// Payment Plan Notes max length
export const PAYMENT_PLAN_NOTE_MAX_LENGTH = 45;
